import type { QuestDoc } from './schemas'

export const enabledQuests = (
  quests: readonly QuestDoc[]
): readonly QuestDoc[] => quests.filter(q => q.entity.enabled)
